import React from 'react';
import { Button } from './ui/button';
import { ChevronLeft, ChevronRight, ChevronsLeft, ChevronsRight } from 'lucide-react';

const PaginationBar = ({ pagination, onPageChange, themeColors }) => {
  const { page, pages, total } = pagination;
  if (pages <= 1) return null;

  const maxVisible = 5;
  let start = Math.max(1, page - Math.floor(maxVisible / 2));
  let end = start + maxVisible - 1;
  if (end > pages) {
    end = pages;
    start = Math.max(1, end - maxVisible + 1);
  }
  const pageNumbers = [];
  for (let i = start; i <= end; i++) pageNumbers.push(i);

  return (
    <div className="flex flex-col sm:flex-row items-center justify-between gap-2 py-2" data-testid="pagination-bar">
      <p className="text-xs text-slate-500 order-2 sm:order-1">
        Página {page} de {pages} — {total} registros
      </p>
      <div className="flex items-center gap-1 order-1 sm:order-2">
        <Button variant="outline" size="icon" className="h-8 w-8" disabled={page <= 1} onClick={() => onPageChange(1)} data-testid="pagination-first" title="Primera">
          <ChevronsLeft className="w-4 h-4" />
        </Button>
        <Button variant="outline" size="icon" className="h-8 w-8" disabled={page <= 1} onClick={() => onPageChange(page - 1)} data-testid="pagination-prev" title="Anterior">
          <ChevronLeft className="w-4 h-4" />
        </Button>

        <div className="hidden sm:flex items-center gap-1">
          {start > 1 && <span className="text-xs text-slate-400 px-1">...</span>}
          {pageNumbers.map((p) => (
            <Button
              key={p}
              variant={p === page ? 'default' : 'outline'}
              size="icon"
              className="h-8 w-8 text-xs"
              style={p === page ? { backgroundColor: themeColors?.primaryColor || '#1a1a2e', color: '#fff' } : {}}
              onClick={() => onPageChange(p)}
              data-testid={`pagination-page-${p}`}
            >
              {p}
            </Button>
          ))}
          {end < pages && <span className="text-xs text-slate-400 px-1">...</span>}
        </div>

        <span className="sm:hidden text-xs font-medium text-slate-700 px-2">{page}/{pages}</span>

        <Button variant="outline" size="icon" className="h-8 w-8" disabled={page >= pages} onClick={() => onPageChange(page + 1)} data-testid="pagination-next" title="Siguiente">
          <ChevronRight className="w-4 h-4" />
        </Button>
        <Button variant="outline" size="icon" className="h-8 w-8" disabled={page >= pages} onClick={() => onPageChange(pages)} data-testid="pagination-last" title="Última">
          <ChevronsRight className="w-4 h-4" />
        </Button>
      </div>
    </div>
  );
};

export default PaginationBar;
